import React from 'react';

class Dealers extends React.Component  {
    render() {
        return(
            <section className="content-section-02 dealers">
                <div className="container">
                    <div className="section-title text-center">
                        <h2>ASCEND PARTNERS</h2>
                        <p>Currently we have 100+ Ascend Partners onboarded with us. If you are an E-Rickshaw dealer, L5 dealer or manufacturer then join our vast list of Dealer or Channel Partner network and grow with us.</p>
                    </div>
                    <div className="row mb-d-30">
                        <div className="col-md-6 col-lg-4 mb--30">
                            <div className="feature-card">
                                <div className="card-icon">
                                    <img src="images/bhopal_singh.jpg"/>
                                </div>
                                <div className="card-content">
                                    <p>Ascend Capital disbursement process is very smooth and because of instant approvals we see huge improvement in customer conversion ratio </p>
                                    <p><b>Narendra - E-Rickshaw Dealer</b></p>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6 col-lg-4 mb--30">
                            <div className="feature-card">
                                <div className="card-icon">
                                    <img src="images/sandeep_singh.jpg"/>
                                </div>
                                <div className="card-content">
                                    <p>Transparent process, easy to use partner app and quick payouts.</p>
                                    <p><b>Ramkishore - Vehicle Loans Channel Partner</b></p>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6 col-lg-4 mb--30">
                            <div className="feature-card">
                                <div className="card-icon">
                                    <img src="images/shri_ram.jpg"/>
                                </div>
                                <div className="card-content">
                                    <p>Same day disbursement of E-Rickshaw loans. Customer service team is very helpful in explaining loan product in detail to our E-Rickshaw buyers</p>
                                    <p><b>Balgopal - E-Rickshaw Dealer</b></p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}



export default Dealers;



// WEBPACK FOOTER //
// ./src/components/Dealers.js